const ExpiredTokenPage = () => {
  return (
    <div style={{ textAlign: "center", marginTop: "50px" }}>
      <h2>Oops! This link has expired.</h2>
      <p>
        This link has expired due to lack of response for 3 months. To
        reactivate, please contact{" "}
        <a href="mailto:request@oxforddoc.com">request@oxforddoc.com</a>.
      </p>
    </div>
  );
};

export default ExpiredTokenPage;
